<template>
  <div
    class="pc-answer"
    :class="{ 'overflow': dateShow }"
  >
    <!-- 年龄选择 -->
    <ChooseBirthday
      :paperSet="paperSet"
      v-model:show="dateShow"
      @confirm="handleBirthdayConfirm"
    />
  </div>
</template>

<script>
import { reactive, toRefs, computed, onMounted, onBeforeUnmount } from "vue";
import ChooseBirthday from "@/components/ChooseBirthday";
import { useRouter, useRoute } from "vue-router";
import QrCard from "@/components/QrCard";
import { Notify, Toast } from "vant";
import {
  getExamPaper,
  answerSave,
  examPaperSave,
  getDetailAnswer,
} from "@/api/goods";
import { setBirthday, } from "@/api/common";
import { checkGoodsOrder } from "@/api/pay";
// import { optionNames } from "../letter";
import { Picker } from 'vant'
import qs from "qs";
import { loadingToast } from "@/plugins/vant";

export default {
  name: "Promotional",
  components: {
    ChooseBirthday,
    QrCard,
    Picker
  },

  setup() {
    const router = useRouter();
    const route = useRoute();

    // 试卷订单ID
    const { paper_order_sn, guid, puid, coupon_code } = route.query;

    const state = reactive({
      // 评测须知显示隐藏
      questionVisible: false,
      // 当前题目索引
      currentIndex: 0,
      // 已回答的题目
      answerList: [],

      // 试卷列表
      examPaper: [],

      isStop: true,

      // 商品信息
      goodsInfo: {},

      // 生日选择
      dateShow: true,

      // 试卷信息
      paper_info: {},
      //动画显示隐藏
      animate: true,

      paperSet: {},
      columns: new Array(75).fill(1).map((e, i) => i + 1),
      showPicker: true
    });

    // 生日选择确定按钮
    async function handleBirthdayConfirm(age) {

    
      await setBirthday({
        age: Number(age),
        paper_order_sn,
      });

      handleReport()
    }

    // 查看报告
    async function handleReport() {
      try {
        // await examPaperSave({
        //   paper_order_sn,
        //   answerData: JSON.parse(localStorage.getItem('answerList')),
        // });
        const { data } = await checkGoodsOrder({ paper_order_sn });


        window.loading = loadingToast()

        if (data === 1) {
          // 跳转支付引导页
          router.replace({
            path: "/report",
            query: {
              paper_order_sn,
              guid,
              puid,
              percent: state.answerList.length,
            },
          });
        } else {
          // 跳转支付引导页
          router.replace({
            path: "/pay",
            query: {
              paper_order_sn,
              guid,
              puid,
              percent: state.answerList.length,
              coupon_code
            },
          });
        }

      } catch (error) {
        Toast("网络异常，请重新提交");
      }
    }
    onBeforeUnmount(() => {
      state.notify?.close();
    });

    // 检查订单状态
    function checkStatus() {
      return new Promise(async (resolve, reject) => {
        const { paper_order_sn, guid, puid, type } = route.query;
        // 重测订单 则不检测 并清除重测参数
        if (type === "reset") {
          const query = {
            ...route.query,
            type: undefined,
          };
          const search = qs.stringify(query);
          window.history.replaceState(
            null,
            null,
            `${window.location.origin + route.path}?${search}`
          );
          resolve();
          return;
        }
        const { data } = await checkGoodsOrder({ paper_order_sn });
        if (data === 1) {
          router.replace({
            path: "/goods",
            query: {
              guid,
              puid,
            },
          });
          reject();
        } else {
          resolve();
        }
      });
    }

    async function init() {
      state.paperSet = JSON.parse(localStorage.statePaperSet)
      try {
        // const {
        //   data: { paper_order_detail, goods_info, paper_info, paperSet },
        // } = await getExamPaper({ paper_order_sn });
        // state.examPaper = paper_order_detail;
        // state.goodsInfo = goods_info;
        // state.paper_info = paper_info;
        // state.time = paper_info.countdown * 60 * 1000;
        // state.paperSet = paperSet;
      } catch (error) {
        console.log(error)
        return false
        // if (puid || guid) {
        //   router.replace({
        //     path: "/goods",
        //     query: {
        //       puid,
        //       guid,
        //     },
        //   });
        // } else {
        //   router.replace("/");
        // }
      }
    }
    onMounted(async () => {
      window.loading?.close?.()

      // await checkStatus();
      await init();

    })


    const onConfirm = (e) => {
      console.log(e)
    }
    return {
      handleBirthdayConfirm,
      onConfirm,
      ...toRefs(state),
    };
  },
};
</script>
<style lang="less">
.pc-notify {
  width: 768px;
  left: 50%;
  transform: translateX(-50%);
}

.van-haptics-feedback {
  font-size: 18px;
}

.van-picker__confirm {
  font-weight: 500;
  color: #ff5d7d;
}

.van-picker-column__item--selected {
  font-size: 20px;
}
</style>
<style lang="less" scoped>
.animate-next {
  animation-duration: 0.3s;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-name: next;
}

.overflow {
  height: 100vh;
  overflow: hidden;
}

@keyframes next {
  0% {
    transform: translateX(500px) scale(0.7);
    opacity: 0.7;
  }

  80% {
    transform: translateX(0) scale(0.7);
    opacity: 0.7;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.active {
  background-color: @theme-color;
  color: #fff;
  transition: all 0.3s;
}

.pc-qrcard-content {
  width: 160px;
  display: flex;
  justify-content: center;

  :deep(.pc-qrcard) {
    border: none;
    padding: 0;
    width: 160px;

    .left {
      width: 120px !important;
      height: 120px !important;
    }

    .right {
      justify-content: flex-start;
      font-size: 14px !important;
      padding: 10px 0 0 0;
      line-height: 20px;
      text-align: center;
    }
  }
}

.pc-answer {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  .scroll-bar();

  .pc-title {
    text-align: center;
    font-size: 30px;
    color: @theme-color;
    font-weight: bold;
    padding: 10px;
  }

  .pc-text {
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: @gray-color;

    .pc-item {
      padding: 0 5px;
    }
  }

  .pc-progress-content {
    .space-between();
    .align-center();
    padding: 10px 5px;
    height: 60px;

    .pc-progress {
      flex: 1;
    }

    .pc-num {
      font-size: 14px;
      font-weight: bold;
      padding: 0 10px 0 5px;
    }

    .pc-reset {
      color: @theme-color;
      font-size: 14px;
      height: 100%;
      cursor: pointer;
      .align-center();
    }
  }

  .pc-topic-content {
    .pc-topic-title {
      font-size: 22px;
      font-weight: bold;
      padding: 10px 0 20px 0;
    }

    .pc-topic-text {
      .item {
        font-size: 16px;
        border-radius: 5px;
        border: 1px solid #e5e5e5;
        overflow: hidden;
        margin-bottom: 20px;
        cursor: pointer;
        .align-center;
        position: relative;

        .left {
          font-weight: bold;
          padding: 0 30px;
          background-color: @theme-color;
          color: #fff;
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 70px;
          .align-center;
        }

        .right {
          padding: 13px 0;
          margin-left: 90px;
          line-height: 25px;
        }
      }
    }

    .pc-topic-img {
      width: 340px;
    }

    .pc-topic-picture {
      .pc-card-content {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;

        .pc-card-item {
          width: 170px;
          height: 80px;
          border: 1px solid #e5e5e5;
          margin: 0 10px 10px 0;
          .align-center;
          justify-content: center;
          cursor: pointer;

          .pc-card-img {
            height: 90%;
          }
        }
      }
    }
  }

  .pc-last-next {
    .align-center;
    justify-content: center;
    padding: 20px 0;
    border-bottom: 1px solid #eeeeee;

    .pc-button {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 5px;
      color: #fff;
      background-color: @theme-color;
      margin-right: 10px;
      font-size: 16px;
      cursor: pointer;

      &.check-report {
        width: 160px;
      }
    }
  }

  .pc-instructions {
    padding: 30px 0;
    font-size: 14px;
    line-height: 30px;

    .item {
      flex: 1;
      padding-right: 30px;
    }

    .space-between();
  }
}
</style>